import * as React from "react";
import { FC } from "react";
import classNames from "classnames";
import Trash from "components/icons/trash";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import { themeOptions } from "styles/theme";

interface IProps {
    className?: string;
    onDelete?(event?: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}

export const Preview: FC<IProps> = ({ className, onDelete, children }) => {
    const classes = useStyles();
    return (
        <div className={classNames(classes.container, className)}>
            {children}
            {onDelete && (
                <IconButton className={classes.iconContainer} onClick={onDelete}>
                    <Trash viewBox="0 0 18 24" className={classes.icon} />
                </IconButton>
            )}
        </div>
    );
};

const useStyles = makeStyles({
    container: {
        position: "relative",
    },
    iconContainer: {
        position: "absolute",
        top: "20px",
        right: "20px",
        borderRadius: "50%",
        backgroundColor: "#fff",
        cursor: "pointer",
        boxShadow: "0 2px 12px 0 rgba(45, 45, 45, 0.2)",
        zIndex: 10,
        "&:hover": {
            backgroundColor: themeOptions.palette.timelineBackgroundColor,
        },
    },
    icon: {
        color: "red !important",
    },
});
